import { render, staticRenderFns } from "./BackupsCleanUp.vue?vue&type=template&id=3635baf8&scoped=true&"
import script from "./BackupsCleanUp.vue?vue&type=script&lang=js&"
export * from "./BackupsCleanUp.vue?vue&type=script&lang=js&"
import style0 from "./BackupsCleanUp.vue?vue&type=style&index=0&id=3635baf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3635baf8",
  null
  
)

export default component.exports